var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.745 9.51501L12.865 7.75501C12.39 6.80001 11.61 6.80001 11.13 7.75501L10.25 9.51501C10.13 9.76001 9.81002 9.99501 9.54502 10.04L7.95002 10.305C6.93002 10.475 6.69502 11.215 7.42502 11.945L8.66502 13.185C8.87502 13.395 8.99002 13.8 8.92502 14.09L8.57002 15.625C8.29002 16.835 8.94002 17.31 10.01 16.675L11.505 15.79C11.78 15.63 12.225 15.63 12.495 15.79L13.99 16.675C15.065 17.31 15.71 16.84 15.43 15.625L15.075 14.09C15.01 13.8 15.125 13.395 15.335 13.185L16.575 11.945C17.31 11.215 17.07 10.475 16.05 10.305L14.455 10.04C14.185 9.99501 13.865 9.76001 13.745 9.51501Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNew);
export default __webpack_public_path__ + "static/media/StatusNew.e9352d57.svg";
export { ForwardRef as ReactComponent };